import { Helmet } from "react-helmet";
import Container from "react-bootstrap/esm/Container";
import { ResponsiveBreadcrumb } from "../../components/Layout/ResponsiveBreadcrumb";
import { appRoutes, SectionLabels } from "../../utils";
import WebsiteSettingsForm from "./WebsiteSettingForm";

const WebsiteSettingListPage = () => {
    return (
        <Container fluid>
            <Helmet>
                <title>Website Settings</title>
            </Helmet>

            <ResponsiveBreadcrumb
                items={[
                    { text: SectionLabels.settings, to: "/settings" },
                    { text: SectionLabels.adminFoundation, to: appRoutes.systemSetup },
                    { text: "Website Settings" },
                ]}
            />

            <h1 className="my-3">Website Settings</h1>
            <WebsiteSettingsForm />
        </Container>
    );
};

export { WebsiteSettingListPage };

